export const WRITABLE_SPACES_QUERY_KEY = 'writable-spaces';
export const SPACE_ICONS_QUERY_PATH = '/rest/spaces/icons';
/**
 * Cache lifetime for per-icon entries. Symbols are immutable per deploy, and
 * push-seeded entries must outlive the 5-minute default gcTime — garbage
 * collection also deletes their persisted IndexedDB records.
 */
export const SPACE_ICON_GC_TIME_MS = 24 * 60 * 60 * 1000;
/** Mirrors the backend cap on POST /rest/spaces/icon. */
export const MAX_SPACE_ICONS_BATCH_SIZE = 100;
/** Served symbol id namespace; keep in sync with DATA_ICON_ID_PREFIX in tools/icons/generate_icon_data.py. */
export const SPACE_ICON_ID_PREFIX = 'pplx-data-';
//# sourceMappingURL=constants.js.map